import { EnumValues } from '@/services/types/EnumValues';
import { ReceiptExemptionReasonEnum } from '@/services/types/TransactionData';

export const getHumanReadableReceiptExemption = (
  reason: EnumValues<typeof ReceiptExemptionReasonEnum>
) => {
  switch (reason) {
    case ReceiptExemptionReasonEnum.LostReceipt:
      return 'Lost receipt';
    case ReceiptExemptionReasonEnum.NoReceiptGiven:
      return 'No receipt given';
    case ReceiptExemptionReasonEnum.DamagedOrFadedReceipt:
      return 'Damaged or faded receipt';
  }
};
